export default __webpack_public_path__ + "media/zurb/img/about/talent/talent-img2-44efcbf324fb34a9aec8dcc64fccfe57.jpg";